function isValidPhone(value) {
    return /^\d{10}$/gm.test(value);
}

function removeWhitespaces(value) {
    if (typeof value === 'string') {
        return value.replace(/^\s+/g, '');
    } else {
        return value;
    }
}

function isValidEmail(email) {
    return /.+@.+\.(.+){2,}$/.test(email);
}

export default {
    validateField(fieldName, value) {
        value = removeWhitespaces(value);

        if (value.length === 0) {
            return false;
        } else if (fieldName === "phone") {
            return isValidPhone(value);
        } else if (fieldName === 'email') {
            return isValidEmail(value);
        } else {
            return true;
        }
    },

    formatPhoneNumber(event, phoneNumberInput) {
        let rawValue = phoneNumberInput.value.replace(/\D/g, '');
        let rawLength = rawValue.length;
        let inputString;

        // allow navigation
        if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
            return;
        }

        // Limit input length
        if (rawLength > 10) {
            inputString = "(" + rawValue.slice(0, 3) + ") " + rawValue.slice(3, 6) + "-" + rawValue.slice(6, 10);
            phoneNumberInput.value = inputString;
            this.setCaretPosition(phoneNumberInput, inputString.length);
            return;
        }

        // reset to focus value
        if (rawLength === 0) {
            phoneNumberInput.value = "(___) ___-____";
            this.setCaretPosition(phoneNumberInput, 1);
            return;
        }

        if (rawLength >= 1 && rawLength <= 3) {
            inputString = "(" + rawValue;

            while (inputString.length < 4) {
                inputString += "_";
            }

            inputString += ") ___-____";
            phoneNumberInput.value = inputString;

            if (rawLength === 3) {
                if (event.key === "Backspace") {
                    this.setCaretPosition(phoneNumberInput, rawLength + 1);
                } else {
                    this.setCaretPosition(phoneNumberInput, rawLength + 3);
                }
            } else {
                this.setCaretPosition(phoneNumberInput, rawLength + 1);
            }
        } else if (rawLength >= 4 && rawLength <= 6) {
            inputString = "(" + rawValue.slice(0, 3) + ") " + rawValue.slice(3);

            while (inputString.length < 9) {
                inputString += "_";
            }

            inputString += "-____";
            phoneNumberInput.value = inputString;

            if (rawLength === 6) {
                if (event.key === "Backspace") {
                    this.setCaretPosition(phoneNumberInput, rawLength + 3);
                } else {
                    this.setCaretPosition(phoneNumberInput, rawLength + 4);
                }
            } else {
                this.setCaretPosition(phoneNumberInput, rawLength + 3);
            }
        } else {
            inputString = "(" + rawValue.slice(0, 3) + ") " + rawValue.slice(3, 6) + "-" + rawValue.slice(6);

            while (inputString.length < 14) {
                inputString += "_";
            }

            phoneNumberInput.value = inputString;
            this.setCaretPosition(phoneNumberInput, rawLength + 4);
        }
    },

    setCaretPosition(input, position) {
        input.focus();
        input.setSelectionRange(position, position);
    }
};
